var resources = require('items-view-strings');
    var strings = resources['_iVvleHveU0wmV8S1IE0zlg'];
export { strings };
export default strings;
